import dayjs from "dayjs";
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

interface ClinicianStatistic {
    created_at: string;
    created_diaries: number;
}

interface CreatedDiairesSparkChartProps {
    cliniciansStats: ClinicianStatistic[];
}

function CreatedDiairesSparkChart({ cliniciansStats }: CreatedDiairesSparkChartProps) {
    const chartData = cliniciansStats.map((stat) => ({
        date: new Date(stat.created_at).getTime(),
        diaries: stat.created_diaries,
    }));

    const max = Math.max(...cliniciansStats.map((s) => s.created_diaries));
    const maxY = Math.ceil(max / 10) * 10;

    const penultimate = cliniciansStats[cliniciansStats.length - 2]?.created_diaries;
    const increase = penultimate ? max - penultimate : 0;
    const percentage = penultimate ? Math.round((increase / penultimate) * 100) : 0;

    return (
        <div className="flex flex-col justify-between w-full h-40">
            <div>
                <div className="font-bold text-2xl">{max} Diaries</div>
                <div className="flex justify-between text-sm">
                    <span>+{increase} Diaries</span>
                    <span>+{percentage}%</span>
                </div>
            </div>
            <div className="w-full h-24">
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart data={chartData}>
                        <XAxis dataKey="date" hide />
                        <YAxis domain={[0, maxY]} hide />
                        <Tooltip
                            content={({ active, payload }) => {
                                if (!active || !payload?.length) return null;
                                return (
                                    <div className="bg-white shadow-sm p-2 border border-slate-200 rounded-md text-sm">
                                        <div className="font-medium">
                                            {dayjs(payload[0].payload.date).format("DD MMM YYYY")}
                                        </div>
                                        <div className="mt-1">Diaries: {payload[0].payload.diaries}</div>
                                    </div>
                                );
                            }}
                        />
                        <Line
                            type="monotone"
                            dataKey="diaries"
                            stroke="hsl(var(--chart-1))"
                            strokeWidth={3}
                            dot={{ r: 4 }}
                        />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}

export default CreatedDiairesSparkChart;
